import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import CardMediaThumbnail from '../../../../CardMediaThumbnail';
function CreativeCard(props) {
    const { name, url, frequency } = props.data;
    return (_jsxs(Stack, Object.assign({ direction: "row", spacing: 5 }, { children: [_jsx(CardMediaThumbnail, { url: url, thumbnail: "", style: { width: 128, height: 72 } }), _jsxs(Stack, Object.assign({ spacing: 2 }, { children: [_jsx(Typography, Object.assign({ variant: "h5" }, { children: name })), _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(Typography, Object.assign({ variant: "caption" }, { children: "Frequency :" })), _jsx(Typography, Object.assign({ variant: "body2" }, { children: frequency }))] }))] }))] })));
}
CreativeCard.propTypes = {
    data: PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
        frequency: PropTypes.string,
    }),
};
export default CreativeCard;
